// Copyright 2025, University of Maryland, All Rights Reserved
import { RequestOptions } from './types';

/**
 * Build a URL, handling legacy /api/ prefix removal
 *
 * All API callers should now provide complete paths including:
 * - Admin routes: `/admin/resource`
 * - Workspace routes: `/org/{org_id}/ws/{ws_id}/resource`
 * - Job routes: `/jobs/resource` or `/org/{org_id}/ws/{ws_id}/jobs/resource`
 * - Datasource routes: `/datasource/{data_source}/bills/{session_code}`
 * - User routes: `/org/{org_id}/user/profile`
 * - Health routes: `/health`
 */
export const buildUrl = (path: string, _options: RequestOptions = {}): string => {
  // Handle legacy paths with /api/ prefix
  if (path.startsWith('/api/')) {
    return path.replace('/api', '');
  }

  // Return path as-is - callers are responsible for providing complete paths
  return path.startsWith('/') ? path : `/${path}`;
};